export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const ADD_TO_CART = "ADD_TO_CART";
export const ITEM_UPDATED = "ITEM_UPDATED";
export const ADD_TO_CART_ERROR = "ADD_TO_CART_ERROR";
